document.addEventListener('DOMContentLoaded', function() {
  // Find all sections with the lazy-section class
  const lazySections = document.querySelectorAll('.lazy-section');
  
  if (!lazySections.length) {
    console.log('No lazy sections found');
    return;
  }
  
  console.log('Found ' + lazySections.length + ' lazy sections');
  
  // Keep track of which sections have been shown
  const shownSections = new Set();
  
  // Set initial styles for all sections at once
  lazySections.forEach(function(section) {
    // Don't hide sections that are already in the initial viewport
    const rect = section.getBoundingClientRect();
    if (rect.top < window.innerHeight) {
      // This section is in the initial viewport, don't hide it
      console.log('Section in initial viewport, not hiding: ', section.className);
      return;
    }
    
    // Hide sections below the fold
    section.style.cssText = 'display: none !important; height: 0 !important; overflow: hidden !important;';
    console.log('Initially hidden section: ', section.className);
  });
  
  // Function to check if element is near viewport
  function isNearViewport(element) {
    const rect = element.getBoundingClientRect();
    const windowHeight = window.innerHeight || document.documentElement.clientHeight;
    // Load when element is within 300px of coming into view
    return rect.top - 300 <= windowHeight;
  }
  
  // Function to show sections that are near viewport
  function showVisibleSections() {
    lazySections.forEach(function(section) {
      // Skip if we've already shown this section
      if (shownSections.has(section)) return;
      
      // Check if the section should be shown
      if (isNearViewport(section)) {
        // Show the section
        section.style.cssText = 'display: block !important; height: auto !important; overflow: visible !important;';
        // Add to our set of shown sections so we don't process it again
        shownSections.add(section);
        console.log('Showing section on scroll: ', section.className);
      }
    });
  }
  
  // Don't run on initial page load - only on scroll
  // Add a slight delay to first scroll check to ensure all initial styles are applied
  let hasScrolled = false;
  
  window.addEventListener('scroll', function() {
    if (!hasScrolled) {
      hasScrolled = true;
      // On first scroll, check what should be visible
      showVisibleSections();
    } else {
      // Use requestAnimationFrame for better performance during scrolling
      requestAnimationFrame(showVisibleSections);
    }
  }, { passive: true });
});